/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable fp/no-mutation */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import merge from 'lodash.merge';
import { commonMessages } from '../messages/common';
import { travelMoneyMessages } from '../messages/travel-money';
export const TravelMoneyTranslations = merge(undefined, commonMessages, travelMoneyMessages);
